
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function Returns() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-charcoal via-navy to-charcoal">
      {/* Geometric Overlay */}
      <div className="fixed inset-0 opacity-[0.03] pointer-events-none z-0">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="hexagons" x="0" y="0" width="100" height="87" patternUnits="userSpaceOnUse">
              <path d="M50 0L93.3 25L93.3 62L50 87L6.7 62L6.7 25Z" fill="none" stroke="white" strokeWidth="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hexagons)" />
        </svg>
      </div>

      <Navigation />

      <main className="relative z-10">
        {/* Hero Header */}
        <section className="pt-32 pb-20 px-6">
          <div className="max-w-4xl mx-auto text-center">
            {/* Breadcrumb */}
            <div className="flex items-center justify-center space-x-2 mb-6 text-gold text-sm">
              <Link to="/" className="hover:text-warmGold transition-colors cursor-pointer">Home</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span>Returns</span>
            </div>

            <h1 className="text-white text-5xl md:text-6xl font-bold leading-tight">
              Terms of Sale &<br />Return Policy
            </h1>
          </div>
        </section>

        {/* Policy Content */}
        <section className="pb-24 px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-darkCard border-l-4 border-gold p-12 rounded-lg">
              {/* As-Is Sales */}
              <div className="mb-12">
                <div className="flex items-center space-x-3 mb-4">
                  <i className="ri-file-text-line text-gold text-3xl w-8 h-8 flex items-center justify-center"></i>
                  <h2 className="text-white text-3xl font-bold">"As-Is" Sales</h2>
                </div>
                <div className="w-10 h-1 bg-gold mb-6"></div>
                <p className="text-lightGray text-lg leading-loose">
                  Most asset sales conducted by NEXTLIFE ASSET SALES LLC are performed on an "As-Is, Where-Is" basis unless otherwise specified in the sales agreement. This means that all equipment and assets are sold in their current condition, and buyers accept full responsibility for inspecting items prior to purchase.
                </p>
              </div>

              {/* Inspection Period */}
              <div className="mb-12">
                <div className="flex items-center space-x-3 mb-4">
                  <i className="ri-search-line text-gold text-3xl w-8 h-8 flex items-center justify-center"></i>
                  <h2 className="text-white text-3xl font-bold">Inspection Period</h2>
                </div>
                <div className="w-10 h-1 bg-gold mb-6"></div>
                <p className="text-lightGray text-lg leading-loose mb-6">
                  Buyers are strongly encouraged to inspect all assets prior to purchase. We provide reasonable access to equipment for inspection purposes during business hours.
                </p>
                <div className="bg-gold/10 border border-gold/30 rounded-lg p-6">
                  <p className="text-gold font-semibold text-lg">
                    <strong>Important:</strong> Claims for discrepancies must be made within 48 hours of receipt.
                  </p>
                </div>
              </div>

              {/* Restocking */}
              <div className="mb-12">
                <div className="flex items-center space-x-3 mb-4">
                  <i className="ri-arrow-go-back-line text-gold text-3xl w-8 h-8 flex items-center justify-center"></i>
                  <h2 className="text-white text-3xl font-bold">Restocking</h2>
                </div>
                <div className="w-10 h-1 bg-gold mb-6"></div>
                <p className="text-lightGray text-lg leading-loose mb-6">
                  Approved returns on non-industrial items are subject to a 20% restocking fee. Industrial equipment and machinery sales are typically final and non-returnable due to the specialized nature of these assets.
                </p>
                <div className="bg-lightGray/5 rounded-lg p-6">
                  <p className="text-white">
                    All return requests must be submitted in writing to <a href="mailto:info@nextlifeasset.com" className="text-gold hover:text-warmGold transition-colors cursor-pointer">info@nextlifeasset.com</a> and approved by our sales team before any items are returned.
                  </p>
                </div>
              </div>

              {/* Refunds */}
              <div className="mb-8">
                <div className="flex items-center space-x-3 mb-4">
                  <i className="ri-shield-check-line text-gold text-3xl w-8 h-8 flex items-center justify-center"></i>
                  <h2 className="text-white text-3xl font-bold">Refunds</h2>
                </div>
                <div className="w-10 h-1 bg-gold mb-6"></div>
                <p className="text-lightGray text-lg leading-loose mb-8">
                  Prorated refunds are issued only for documented equipment failure that was not disclosed at the time of sale. All refund claims must be accompanied by:
                </p>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start space-x-3">
                    <span className="text-gold mt-1.5">•</span>
                    <span className="text-lightGray text-lg">Photographic or video evidence of the defect</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-gold mt-1.5">•</span>
                    <span className="text-lightGray text-lg">Professional inspection report (if applicable)</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-gold mt-1.5">•</span>
                    <span className="text-lightGray text-lg">Original sales documentation</span>
                  </li>
                </ul>
                <a
                  href="mailto:info@nextlifeasset.com"
                  className="inline-block px-8 py-3 bg-gold text-black rounded-full font-semibold hover:bg-warmGold transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
